import {
  GET_DATA_RETENTION_SETTINGS,
  GET_DATA_RETENTION_SETTINGS_SUCCESS,
  GET_DATA_RETENTION_SETTINGS_ERROR,
} from './actionTypes';

export const getDataRetentionSettings = (user) => {
  return {
    type: GET_DATA_RETENTION_SETTINGS,
    payload: { user },
  };
};

export const getDataRetentionSettingsSuccess = (settings, message) => {
  return {
    type: GET_DATA_RETENTION_SETTINGS_SUCCESS,
    payload: { settings, message },
  };
};

export const getDataRetentionSettingsError = (msg) => {
  return {
    type: GET_DATA_RETENTION_SETTINGS_ERROR,
    payload: msg,
  };
};
